import { render, staticRenderFns } from "./VesselPrintAgePieIndividualChart.vue?vue&type=template&id=38a444f3&scoped=true&"
import script from "./VesselPrintAgePieIndividualChart.vue?vue&type=script&lang=js&"
export * from "./VesselPrintAgePieIndividualChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a444f3",
  null
  
)

export default component.exports